module.exports = __webpack_public_path__ + "img/2024big27.e018e025.png";